// extracted by mini-css-extract-plugin
export var displayNone = "_un-6";
export var imgContainer = "_un-2";
export var overflowHidden = "_un-3";
export var productInfoCardButtonContainer = "_un-5";
export var productTitleText = "_un-4";
export var rightArrow = "_un-1";
export var rightArrowContainer = "_un-0";